import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Checkbox as MuiCheckbox,
  type CheckboxProps as MuiCheckboxProps,
  FormControlLabel,
} from '@mui/material'
import { FormHelperText } from '../FormHelperText'
import { type DataTestIdAttribute } from '../../types'

export type CheckboxProps = Pick<
  MuiCheckboxProps,
  | 'autoFocus'
  | 'checked'
  | 'defaultChecked'
  | 'disabled'
  | 'edge'
  | 'id'
  | 'indeterminate'
  | 'name'
  | 'onChange'
  | 'onBlur'
  | 'readOnly'
  | 'required'
  | 'slotProps'
  // TODO: ux do you need sizes?
  // | 'size'
  | 'tabIndex'
  | 'value'
> & {
  /**
   * We need a label for accessibility, but you can have your own setup for using
   * an accessible checkbox. In most use cases you will need to have this label.
   */
  label?: React.ReactNode

  /**
   * helper text to show additional information under the Checkbox
   * @default false
   */
  helperText?: React.ReactNode

  /**
   * flag to indicate whether an error occurred, applied to the helperText
   * @default false
   */
  error?: boolean

  isLabelTop?: boolean
} & DataTestIdAttribute

export const Checkbox = ({ label, helperText, error = false, isLabelTop, ...props }: CheckboxProps) => (
  <>
    {label ? (
      <FormControlLabel
        sx={!label ? { mr: 0, width: 'fit-content' } : { m: 0, alignItems: isLabelTop ? 'flex-start' : undefined }}
        control={<MuiCheckbox {...props} />}
        label={label}
      />
    ) : (
      <MuiCheckbox {...props} />
    )}
    {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
  </>
)
